import {
  createOrder,
  getUserOrders,
  getOrderById,
  getAllOrders,
  updateOrderStatus,
  addTrackingNumber,
  getOrderStatistics,
} from "./asyncThunk";

export const createOrderBuilder = (builder) => {
  builder
    .addCase(createOrder.pending, (state) => {
      state.loading.createOrder = true;
      state.errors.createOrder = null;
    })
    .addCase(createOrder.fulfilled, (state, { payload }) => {
      state.loading.createOrder = false;
      state.createdOrder = payload.data;
      // Add to user orders list if exists
      if (state.userOrders.data) {
        state.userOrders.data.unshift(payload.data);
      }
    })
    .addCase(createOrder.rejected, (state, { error }) => {
      state.loading.createOrder = false;
      state.errors.createOrder = error.message || "Failed to create order";
    });
};

export const getUserOrdersBuilder = (builder) => {
  builder
    .addCase(getUserOrders.pending, (state) => {
      state.loading.getUserOrders = true;
      state.errors.getUserOrders = null;
    })
    .addCase(getUserOrders.fulfilled, (state, { payload }) => {
      state.loading.getUserOrders = false;
      state.userOrders.data = payload.data.orders;
      state.userOrders.pagination = {
        page: payload.data.page,
        totalPages: payload.data.totalPages,
        total: payload.data.total,
        limit: payload.data.limit,
      };
    })
    .addCase(getUserOrders.rejected, (state, { error }) => {
      state.loading.getUserOrders = false;
      state.errors.getUserOrders = error.message || "Failed to get user orders";
    });
};

export const getOrderByIdBuilder = (builder) => {
  builder
    .addCase(getOrderById.pending, (state) => {
      state.loading.getOrderById = true;
      state.errors.getOrderById = null;
    })
    .addCase(getOrderById.fulfilled, (state, { payload }) => {
      state.loading.getOrderById = false;
      state.selectedOrder = payload.data;
    })
    .addCase(getOrderById.rejected, (state, { error }) => {
      state.loading.getOrderById = false;
      state.errors.getOrderById = error.message || "Failed to get order";
    });
};

export const getAllOrdersBuilder = (builder) => {
  builder
    .addCase(getAllOrders.pending, (state) => {
      state.loading.getAllOrders = true;
      state.errors.getAllOrders = null;
    })
    .addCase(getAllOrders.fulfilled, (state, { payload }) => {
      state.loading.getAllOrders = false;
      state.allOrders.data = payload.data.orders;
      state.allOrders.pagination = {
        page: payload.data.page,
        totalPages: payload.data.totalPages,
        total: payload.data.total,
        limit: payload.data.limit,
      };
    })
    .addCase(getAllOrders.rejected, (state, { error }) => {
      state.loading.getAllOrders = false;
      state.errors.getAllOrders = error.message || "Failed to get all orders";
    });
};

export const updateOrderStatusBuilder = (builder) => {
  builder
    .addCase(updateOrderStatus.pending, (state) => {
      state.loading.updateOrderStatus = true;
      state.errors.updateOrderStatus = null;
    })
    .addCase(updateOrderStatus.fulfilled, (state, { payload }) => {
      state.loading.updateOrderStatus = false;
      const updatedOrder = payload.data.order;
      // Update the order in all orders list if exists
      if (state.allOrders.data) {
        const index = state.allOrders.data.findIndex(
          order => String(order.id) === String(updatedOrder.id)
        );
        if (index !== -1) {
          state.allOrders.data[index] = updatedOrder;
        }
      }
      // Update selected order if it's the same one
      if (state.selectedOrder && String(state.selectedOrder.id) === String(updatedOrder.id)) {
        state.selectedOrder = updatedOrder;
      }
    })
    .addCase(updateOrderStatus.rejected, (state, { error }) => {
      state.loading.updateOrderStatus = false;
      state.errors.updateOrderStatus = error.message || "Failed to update order status";
    });
};

export const addTrackingNumberBuilder = (builder) => {
  builder
    .addCase(addTrackingNumber.pending, (state) => {
      state.loading.addTrackingNumber = true;
      state.errors.addTrackingNumber = null;
    })
    .addCase(addTrackingNumber.fulfilled, (state, { payload }) => {
      state.loading.addTrackingNumber = false;
      const updatedOrder = payload.data.order;
      // Update the order in all orders list if exists
      if (state.allOrders.data) {
        const index = state.allOrders.data.findIndex(
          order => String(order.id) === String(updatedOrder.id)
        );
        if (index !== -1) {
          state.allOrders.data[index] = updatedOrder;
        }
      }
      // Update selected order if it's the same one
      if (state.selectedOrder && String(state.selectedOrder.id) === String(updatedOrder.id)) {
        state.selectedOrder = updatedOrder;
      }
    })
    .addCase(addTrackingNumber.rejected, (state, { error }) => {
      state.loading.addTrackingNumber = false;
      state.errors.addTrackingNumber = error.message || "Failed to add tracking number";
    });
};

export const getOrderStatisticsBuilder = (builder) => {
  builder
    .addCase(getOrderStatistics.pending, (state) => {
      state.loading.getOrderStatistics = true;
      state.errors.getOrderStatistics = null;
    })
    .addCase(getOrderStatistics.fulfilled, (state, { payload }) => {
      state.loading.getOrderStatistics = false;
      state.statistics = payload.data;
    })
    .addCase(getOrderStatistics.rejected, (state, { error }) => {
      state.loading.getOrderStatistics = false;
      state.errors.getOrderStatistics = error.message || "Failed to get order statistics";
    });
};